import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { RevenueItemService } from '../shared/revenue-items/revenue-item.service';
import { RevenueItem } from '../shared/revenue-items/revenue-item.model';
import { NameVal } from '../../shared/model/name-val.model';
import { NotificationService } from '../../shared/notification/notification.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { UtilService } from '../../shared/util/util.service';

import { ArcService, ArcFormula, ArcBuilderRow, ArcBuilderField, ArcBuilderFieldEnum } from '../shared/arc/index';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'wl-arc-builder',
  templateUrl: 'arc-builder.component.html',
    standalone: false
})
export class ArcBuilderComponent implements OnInit {
  private _arcService: ArcService;
  private _revenueItemService: RevenueItemService;
  private _router: Router;
  private _notificationService: NotificationService;
  private _translationService: TranslationService;
  private _utilService: UtilService;

  public revenueItems: Array<RevenueItem>;
  public arcFormula: ArcFormula;
  public fieldList: Array<ArcBuilderField>;
  public arcBuilderRows: Array<ArcBuilderRow>;
  public selectedField: ArcBuilderField;
  public selectedFieldName: string;
  public showFormulaField: boolean = false;
  public showFormulaToggle: boolean = false;
  public constructor(
    arcService: ArcService,
    revenueItemService: RevenueItemService,
    private _route: ActivatedRoute,
    notificationService: NotificationService,
    translationService: TranslationService,
    utilService: UtilService,
    router: Router,
    private _title: Title
  ) {
    this._arcService = arcService;
    this._revenueItemService = revenueItemService;
    this._router = router;
    this._notificationService = notificationService;
    this._translationService = translationService;
    this._utilService = utilService;
  }

  ngOnInit() {
    this._revenueItemService.getRevenueItems().then((data: Array<RevenueItem>) => {
      this.revenueItems = data;
    });

    this.arcFormula = new ArcFormula();
    this.arcBuilderRows = new Array<ArcBuilderRow>();
    this.selectedField = null;

    this._arcService.getArcBuilderFieldList().then((data: any) => {
      this.fieldList = data;

      //load existing formula
      this._route.paramMap
        //.map(params => params['id'])
        .subscribe((params) => {
          let id = parseInt(params.get('id'));
          if (id > 0) {
            this._arcService.getArc(id).then((data: ArcFormula) => {
              this.arcFormula = data;
              this._title.setTitle(data.Descr);
              if (this._utilService.isNullOrUndefined(data.ARCBuilderRows)) {
                this.showFormulaField = true;
              } else {
                this.arcBuilderRows = data.ARCBuilderRows;
                this.selectedField = this.fieldList.find(
                  (x) => x.FieldType == this.arcBuilderRows[0].SelectedFieldType && x.FieldId == this.arcBuilderRows[0].SelectedFieldId
                );
              }
            });
          } else {
            this.showFormulaToggle = true;
          }
        });
    });
  }

  public selectedFieldTypeChange() {
    //switch (this.selectedField.FieldType) {
    //    case ArcBuilderFieldEnum.Profile_EmployeesFT:
    var initialRow = new ArcBuilderRow();
    initialRow.SelectedFieldType = this.selectedField.FieldType;
    initialRow.SelectedFieldId = this.selectedField.FieldId;
    initialRow.RangeStart = 1;
    initialRow.RangeEnd = 10;
    this.arcBuilderRows.push(initialRow);

    var defaultRow = new ArcBuilderRow();
    defaultRow.SelectedFieldType = this.selectedField.FieldType;
    defaultRow.SelectedFieldId = this.selectedField.FieldId;
    defaultRow.IsDefault = true;
    this.arcBuilderRows.push(defaultRow);
    //      break;
    //}
  }

  public addRow(): void {
    let index = 0;
    if (!this.arcBuilderRows[this.arcBuilderRows.length - 1].IsDefault || this.arcBuilderRows.length <= 1) {
      index = this.arcBuilderRows.length - 1;
    } else {
      index = this.arcBuilderRows.length - 2;
    }
    let row: ArcBuilderRow = this._utilService.clone(this.arcBuilderRows[index]);
    row.RangeStart = row.RangeEnd + 1;
    row.RangeEnd = 0;

    this.arcBuilderRows.splice(this.arcBuilderRows.length - 1, 0, row);
  }

  public removeRow(index: number): void {
    this.arcBuilderRows.splice(index, 1);
  }

  public saveArc(): void {
    this.arcFormula.ARCBuilderRows = this.arcBuilderRows;

    if (this.showFormulaField) {
      this.arcFormula.ARCBuilderRows = null;
    }

    if (this.arcFormula.ArcID > 0) {
      this._arcService.updateArc(this.arcFormula).then(() => {
        this._translationService.get('revenue.arc.arc-saved').then((message: string) => {
          this._notificationService.success(message);
        });
      }).catch((err) => {
        this._notificationService.httpError(err);
      });
    } else {
      this._arcService.createArc(this.arcFormula).then((data: number) => {
        if (data > 0) {
          this._translationService.get('revenue.arc.arc-saved').then((message: string) => {
            this._notificationService.success(message);
            this._router.navigate([`revenue/pricing-calculations/${data}`]);
          }).catch((err) => {
            this._notificationService.httpError(err);
          });;
        }
      });
    }
  }

  public cancel(): void {
    this._router.navigate(['revenue/pricing-calculations']);
  }

  public toggleFormulaField() {
    this.showFormulaField = !this.showFormulaField;
  }
}
